import { useState, useCallback } from "react";

/**
 * Custom hook for managing camera feed UI state
 */
export function useCameraFeedState() {
  const [showStockOverlay, setShowStockOverlay] = useState<boolean>(true);

  const toggleStockOverlay = useCallback(() => {
    setShowStockOverlay(prev => !prev);
  }, []);

  return {
    showStockOverlay,
    toggleStockOverlay,
  };
} 